<template>
  <Modal v-model="visible" @on-ok="ok" @on-cancel="cancel" :loading="modalLoading" 
     :okText="getTranslation('c006')" :cancelText="getTranslation('b182')" :title="title" closable mask-closable
     width="35">
    <Row class="field-line" type="flex">
      <Col flex="5" class="desc-field">
      {{ getTranslation('p005') }}<Icon type="md-star" class="need-icon" />
      </Col>
      <Col flex="19">
      <Input v-model="productline.name" maxlength="100" />
      </Col>
    </Row>
    <Row class="field-line" type="flex">
      <Col flex="5" class="desc-field">
      {{ getTranslation('m013') }}<Icon type="md-star" class="need-icon" />
      </Col>
      <Col flex="19">
      <Input v-model="productline.seq" type="number" />
      </Col>
    </Row>
    <Row class="field-line" type="flex">
      <Col flex="5" class="desc-field">
      {{ getTranslation('p006') }}
      </Col>
      <Col flex="19">
      <Input v-model="productline.remark" type="textarea" :rows="3" maxlength="60" />
      </Col>
    </Row>
    <div slot="footer">
        <Row type="flex" class="menu-actions">
          <Col flex="1" class="flex-right">
            <Button type="text" @click="cancel" icon="md-close" >{{ getTranslation('b182') }}</Button>&nbsp;
            <Button type="primary" @click="ok" icon="md-checkmark" >{{ getTranslation('c006') }}</Button>            
          </Col>
        </Row>
      </div>
  </Modal>

</template>
<script>
import { API_URL } from '@/constants/const.js'
import axios from 'axios';
import { Modal, Row, Col, Input, Icon,Button } from 'view-design';
import { mapGetters } from 'vuex'
import { checkSeqCorrect, postJsError } from '@/util/util.js'
export default {
  name: 'ProductlineEdit', // 组件名称
  components: {
    Modal, Row, Col, Input,Icon,Button
  },
  props: {
    propVisible: Boolean,
    editId: Number
  },
  data() {
    return {
      productline: {},
      title: '',
      modalLoading: true,

    }
  },
  computed: {
    ...mapGetters(['getTranslation']),
    visible: {
      get() { return this.propVisible },
      set(val) { this.$emit('input', val) }
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        if (this.editId > 0) {
          this.title = this.getTranslation('p002');
          this.getOneProductline(this.editId)
        } else {
          this.title = this.getTranslation('p001');
          this.productline = {
            seq: 10
          }
        }
      }
    }
  },

  created() {

  },
  methods: {
    getOneProductline(id) {
      let url = API_URL["productlineGetOne"];
      let params = {
        id: id
      }

      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.productline = res.data.data;
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          } else {
            this.$Message.error(this.getTranslation('c001'));
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    ok() {
      let _this = this;
      this.modalLoading = true;
      if (!this.validateForm()) {
        this.modalLoading = false;
        this.resetModal();
        return;
      }
      let url = API_URL["productlineAdd"];
      if (this.editId > 0) {
        url = API_URL["productlineUpdate"];
      }
      let params = this.productline;
      axios.get(url, {
        params: params
      })
        .then(res => {
          if (res && res.data && res.data.code && res.data.code == 200) {
            if (this.editId > 0) {
              this.$Message.success(this.getTranslation('p007'));
            } else {
              this.$Message.success(this.getTranslation('p008'));
            }
            this.visible = false
            _this.$emit("refresh-page")

          } else if (res && res.data && res.data.code && res.data.msg) {
            this.$Message.error(res.data.msg);
            this.modalLoading = false;
            this.resetModal();
          } else {
            this.$Message.error(this.getTranslation('c001'));
            this.modalLoading = false;
            this.resetModal();
          }
        })
        .catch((err) => {
          postJsError(err)
          this.modalLoading = false;
          this.resetModal();
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    validateForm() {
      let errorMsg = '';
      let isValid = true;
      this.productline.seq = Number(this.productline.seq);
      if (!this.productline.name || this.productline.name.length < 2) {
        errorMsg = this.getTranslation('p010');
        isValid = false;
      } else if (!checkSeqCorrect(this.productline.seq)) {
        errorMsg = this.getTranslation('p011');
        isValid = false;
      }
      if (errorMsg) {
        this.$Message.error(errorMsg);
      }
      return isValid;
    },
    resetModal() {
      this.$nextTick(() => {
        this.modalLoading = true;
      });
    },
    cancel() {
      this.visible = false;
    }
  },

}
</script>

<style scoped>
@import url('../../../assets/style/list.css'); 
.desc-field {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 3%;
  font-size: 0.9rem;
  font-weight: 500;
}

.field-line {
  margin-bottom: 8px;
}
</style>